import { FormattedEvent } from '@eventbrite/event-renderer';
import { getExperiment } from '@eventbrite/statsig';

export enum RelatedEventsSlotsVariants {
    CONTROL = '1',
    SLOTS_1_AND_3 = '1&3',
}

export function getRelatedEventsSlots() {
    const variant = getRelatedEventsSlotsVariant();
    return variant === RelatedEventsSlotsVariants.CONTROL ? 1 : 2;
}

function getRelatedEventsSlotsVariant() {
    const value = getExperiment<
        RelatedEventsSlotsVariants,
        RelatedEventsSlotsVariants
    >(
        'listings_related_events_2_ads_slots',
        'slots',
        RelatedEventsSlotsVariants.CONTROL,
    );

    return value;
}

export function getSortedEvents(
    events: FormattedEvent[],
    promotedEvents: FormattedEvent[],
) {
    const variant = getRelatedEventsSlotsVariant();
    if (variant === RelatedEventsSlotsVariants.CONTROL) {
        return [...promotedEvents, ...events];
    }

    return interleaveTwoArrays(events, promotedEvents as any, [1, 3]);
}

function interleaveTwoArrays<T>(arrayA: T[], arrayB: T[], positions: number[]) {
    let interleavedArray = [...arrayA];

    arrayB.forEach((item, index) => {
        // If no position has been provided, just put the element in the end
        const newPromotedPosition =
            (positions[index] || interleavedArray.length) - 1;

        interleavedArray = interleaveIntoArray(
            interleavedArray,
            item,
            newPromotedPosition,
        );
    });

    return interleavedArray;
}

function interleaveIntoArray<T>(array: T[], element: T, position: number): T[] {
    const result = [...array];

    // If the desired position of A is greater than the current length of the array,
    // insert A at the end of the array.
    if (position > result.length) {
        position = result.length;
    }

    result.splice(position, 0, element);

    return result;
}
